import { z } from 'zod';
import type { $brand } from 'zod/v4/core';

export type UserId = string & $brand<'UserId'>;
export const userIdSchema = z.uuid().transform((id) => id as UserId);
